import {saveGame} from '@wonderlandengine/uber-sdk';

export enum GameProgressItems {
    lastLevel,
    totalMoves,
    totalTeleports,
    totalRestarts,
}

export enum GameSettingItems {
    soundDisbled,
    musicDisabled,
}

export class GameProgress {
    private static _instance: GameProgress;
    static get instance(): GameProgress {
        if (GameProgress._instance === undefined) {
            GameProgress._instance = new GameProgress();
        }
        return GameProgress._instance;
    }

    private _saveGameData: SaveGameData = new SaveGameData();

    private constructor() {
        this._load();
    }

    private _load() {
        saveGame.load(this._saveGameData);
    }

    private _save() {
        saveGame.save(this._saveGameData);
    }

    private _dataChanged() {
        this._save();
    }

    record(name: GameProgressItems, value: number) {
        const stringName = GameProgressItems[name];
        this._saveGameData.data[stringName] = value;
        this._dataChanged();
    }

    recordAdditive(name: GameProgressItems, value: number) {
        const stored = this.get(name);
        this.record(name, stored + value);
    }

    recordHighest(name: GameProgressItems, value: number) {
        const stored = this.get(name);
        if (value > stored) {
            this.record(name, value);
        }
    }

    get(name: GameProgressItems): number {
        const stringName = GameProgressItems[name];
        return this._saveGameData.data[stringName] ?? 0;
    }

    storeSetting(name: GameSettingItems, value: boolean) {
        const stringName = GameSettingItems[name];
        this._saveGameData.settings[stringName] = value;
        this._dataChanged();
    }

    getSetting(name: GameSettingItems): boolean {
        const stringName = GameSettingItems[name];
        return this._saveGameData.settings[stringName] ?? false;
    }
}

class SaveGameData {
    data: Partial<Record<GameProgressItems, number>> = {};
    settings: Partial<Record<GameSettingItems, boolean>> = {};
}
